import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import getRandom from '../util/getRandom';


const INITIAL_STATE = Immutable({
  courses: [],
  isLoading: false,
  isLoadingCards: false,
  isLoadingSearchResults: false,
  cardsByCourse: {},
  currentCards: [],
  selectedCourse: null,
  selectedCourseId: null,
  courseRunStartedAt: null,
  completedDialogOpen: false,
  cardsNotKnown: [],
  previewCourses: [],
  cardForModal: null,
  searchResults: [],
  searchTerm: '',
  bulletinBoard: null,
  bulletinBoardContent: [],
  bulletinBoardCards: [],
  currentCard: null,
});

// api actions
export const onLoadCourses = createAction('ONLOAD_COURSES');
export const onLoadCourse = createAction('ONLOAD_COURSE_CARDS');
export const onLoadCard = createAction('ONLOAD_CARD');

// utils
export const onLoadCoursesFailed = createAction('ONLOADCOURSESFAILED');
export const onLoadCoursesSucceeded = createAction('ONLOADCOURSESSUCCEEDED');


export const onLoadCourseFailed = createAction('ONLOAD_COURSE_CARDS_FAILED');
export const onLoadCourseSucceeded = createAction('ONLOAD_COURSE_CARDS_SUCCEEDED');

export const onLoadCardFailed = createAction('ONLOAD_CARD_FAILED');
export const onLoadCardSucceeded = createAction('ONLOAD_CARD_SUCCEEDED');

export const onCardSwiped = createAction('cardSwipedAction');
export const onFinishRun = createAction('finishRunAction');
export const onRestart = createAction('restartCourseAction');
export const onRetry = createAction('retryCourseAction');
export const onOpenCompletedDialog = createAction('completedDialogOpenAction');
export const onCloseCompletedDialog = createAction('completedDialogOpenAction');

export const onSearch = createAction('searchAction');
export const onSearchSucceeded = createAction('searchSucceeded');
export const onSearchFailed = createAction('searchFailed');

export const onExportContent = createAction('onExportContent');
export const onExportContentFailed = createAction('onExportContentFailed');
export const onExportContentSucceeded = createAction('onExportContentSucceeded');

export const loadDefaultBulletinBoard = createAction('loadDefaultBulletinBoardAction');
export const loadDefaultBulletinBoardSucceeded = createAction('loadDefaultBulltingBoardSuccessAction');
export const getPinnedContentAction = createAction('getPinnedContentAction');
export const getPinnedContentSuccessAction = createAction('getPinnedContentSuccessAction');
export const getPinnedContentFailedAction = createAction('getPinnedContentFailedAction');
export const pinOrUnpinContentAction = createAction('pinOrUnpinContentAction');
export const pinOrUnpinContentSuccessAction = createAction('pinOrUnpinContentSuccess');
export const loadCardsForBulletinBoardAction = createAction('loadCardsForBulletinBoardAction');
export const loadCardsForBulletinBoardSuccessAction = createAction('loadCardsForBulletinBoardSuccessAction');

const findCourse = (courseList, id) => {
  for (let i = courseList.length - 1; i >= 0; i--) {
    const course = courseList[i];

    if (course.type == 'course' && course.id == id) {
      return course;
    }

    if (course.type == 'group' && course.children) {
      for (let j = course.children.length - 1; j >= 0; j--) {
        if (course.children[j].type == 'course' && course.children[j].id == id) {
          return course.children[j];
        }
      }
    }
  }
};

const excludeFromList = (courseList, id) => {
  const courses = courseList.asMutable({ deep: true })
                            .filter(c => c.type == 'group' || (c.type == 'course' && c.id != id));

  for (let i = courses.length - 1; i >= 0; i--) {
    const c = courses[i];
    if (c.type == 'group' && c.children) {
      courses[i].children = courses[i].children.filter(f => f.type == 'course' && f.id != id);
    }
  }

  return courses;
};

const getUpdatedCourseList = (courseList, course, id) => {
  const courses = courseList.asMutable({ deep: true });

  for (let i = courses.length - 1; i >= 0; i--) {
    const c = courses[i];

    if (c.type == 'course' && c.id == id) {
      c[i] = course;
    }

    if (c.type == 'group' && c.children) {
      for (let j = c.children.length - 1; j >= 0; j--) {
        if (c.children[j].type == 'course' && c.children[j].id == id) {
          courses[i].children[j] = course;
        }
      }
    }
  }
  return courses;
};

const getRandomCourses = (groupTree, exclude) => {
  let courses = [];

  if (!groupTree) {
    return [];
  }

  groupTree.forEach((t) => {
    if (t.type == 'group' && t.children) {
      courses = courses.concat(t.children);
    }
  });

  courses = courses.concat(groupTree.filter(c => c.type == 'course'));
  courses = courses.filter(c => !exclude || c.id != exclude.id);

  return getRandom(courses, Math.min(3, courses.length - 1));
};

const cardSwiped = (state, { type, card }) => {
  if (type == 1) {
    const cardsNotKnown = state.cardsNotKnown.asMutable();
    cardsNotKnown.push(card);
    return state.merge({ cardsNotKnown });
  }
  return state;
};

const loadCourse = (state, course) => {
  if (!course) {
    return state;
  }

  const selectedCourse = findCourse(state.courses, course.id) || course;

  return state.merge({
    selectedCourse,
    currentCards: [],
    cardsNotKnown: [],
    isLoadingCards: true,
    selectedCourseId: selectedCourse.id,
  });
};

const loadCards = (state, { course, cards, includeAll }) => {
  if (!cards) {
    return state;
  }

  const cardsByCourse = state.cardsByCourse.setIn([course.id], cards);
  const currentCards = !includeAll ? cards.filter(c => c && c.progress != 1) : cards;

  const selectedCourse = findCourse(state.courses, course.id) || course;
  return state.merge({
    cardsByCourse,
    currentCards,
    isLoadingCards: false,
    courseRunStartedAt: new Date().toISOString(),
    selectedCourse,
    previewCourses: getRandomCourses(state.courses, course),
    completedDialogOpen: currentCards.length == 0 && cards.length > 0,
    selectedCourseId: selectedCourse && selectedCourse.id,
  });
};

const restart = (state) => {
  const currentCards = state.cardsByCourse[state.selectedCourseId];

  return state.merge({
    currentCards,
    cardsNotKnown: [],
    courseRunStartedAt: new Date().toISOString(),
    completedDialogOpen: false,
  });
};

const retry = (state) => {
  let currentCards = state.cardsByCourse[state.selectedCourse.id];
  currentCards = currentCards.filter(c => state.cardsNotKnown.find(cnk => cnk.id == c.id));

  return state.merge({
    currentCards,
    cardsNotKnown: [],
    completedDialogOpen: false,
    courseRunStartedAt: new Date().toISOString(),
  });
};


const handleCardPinning = (state, dto) => {
  const cards = state.currentCards.asMutable({ deep: true });
  const card = cards.find(c => c.id === dto.contentId);
  const indexOfCard = cards.indexOf(cards);
  if (card) {
    card.isPinned = !card.isPinned;
    cards[indexOfCard] = card;
  }

  return state.merge({
    currentCards: cards,
    bulletinBoardCards: card && card.isPinned
      ? state.bulletinBoardCards
      : state.bulletinBoardCards.filter(f => f.id !== dto.contentId),
  });
};

const handleCoursePinning = (state, dto) => {
  const course = findCourse(state.courses, dto.contentId);
  const newCourse = course.asMutable();
  newCourse.isPinned = !course.isPinned;


  const bulletinBoardContent = newCourse.isPinned
    ? getUpdatedCourseList(state.bulletinBoardContent, newCourse, dto.contentId)
    : excludeFromList(state.bulletinBoardContent, newCourse.id);

  return state.merge({
    courses: getUpdatedCourseList(state.courses, newCourse, dto.contentId),
    bulletinBoardContent,
  });
};

const handlePinningAction = (state, dto) => {
  if (dto && dto.contentType && dto.contentType == 'card') {
    return handleCardPinning(state, dto);
  }

  if (dto && dto.contentType && dto.contentType == 'course') {
    return handleCoursePinning(state, dto);
  }

  return state;
};


const reducers = createReducer({
  [onLoadCourses]: state => state.merge({ isLoading: true }),
  [onSearchSucceeded]: (state, result) => state.merge({
    searchResults: result,
    isLoadingSearchResults: false,
  }),
  [onSearchFailed]: state => state.merge({ isLoadingSearchResults: false }),
  [onSearch]: (state, searchTerm) => state.merge({
    searchTerm,
    isLoadingSearchResults: true,
  }),
  [onLoadCoursesSucceeded]: (state, { courses }) => {
    const newState = state.merge({
      courses,
      previewCourses: getRandomCourses(courses, state.selectedCourse),
      isLoading: false,
    });

    return newState.merge({
      selectedCourse: findCourse(newState.courses, newState.selectedCourseId) || newState.selectedCourse,
    });
  },
  [onLoadCourse]: loadCourse,
  [onLoadCourseSucceeded]: loadCards,
  [onRestart]: restart,
  [onRetry]: retry,
  [onCardSwiped]: cardSwiped,
  [pinOrUnpinContentSuccessAction]: handlePinningAction,
  [onOpenCompletedDialog]: state => state.merge({ completedDialogOpen: true }),
  [onCloseCompletedDialog]: state => state.merge({ completedDialogOpen: false }),
  [onLoadCardFailed]: state => state.merge({ cardForModal: null }),
  [onLoadCardSucceeded]: (state, { card }) => state.merge({ cardForModal: card }),

  [getPinnedContentSuccessAction]: (state, bulletinBoardContent) => state.merge({
    bulletinBoardContent,
  }),
  [loadDefaultBulletinBoardSucceeded]: (state, bulletinBoard) => state.merge({
    bulletinBoard,
  }),
  [loadCardsForBulletinBoardSuccessAction]: (state, bulletinBoardCards) => state.merge({ bulletinBoardCards }),
}, INITIAL_STATE);

export default reducers;




// WEBPACK FOOTER //
// ./src/app/reducers/course.reducers.js